import { Message } from 'lib-shared-legacy-types';
import { useMemo } from 'react';

import TextMessage, { TextMessageProps } from './TextMessage';
import { getAttachment } from './utils/attachment';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageWhatsAppProps = {
  message: Message;
} & TextMessageProps;

export const MessageWhatsApp = ({
  markup,
  ...otherProps
}: MessageWhatsAppProps): JSX.Element => {
  const attachment = useMemo(
    () => getAttachment(otherProps.message, { scaleImage: true }),
    [otherProps.message],
  );

  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: otherProps.message.text ?? undefined,
    originalLanguageCode: otherProps.message.language ?? null,
  });

  return (
    <TextMessage
      {...otherProps}
      showMarkupAndContent
      content={attachment}
      gutterButtons={button}
      translation={translation}
    />
  );
};
